module.exports = __webpack_public_path__ + "static/media/31@2x.054f07e3.png";